import React, { useState, useEffect, useRef } from "react";
import mapIcon from "../images/icons/map-icon.png";
import moment from "moment";
import noOutletImg from "../images/no-outlets-message-img.png";
import loadingGif from "../images/loading.gif";
import L, { Icon } from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet/dist/leaflet.css";
var greenIcon = new Icon({
	iconUrl: mapIcon,
	iconSize: [24, 41], // size of the icon
	iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
	popupAnchor: [10, -5], // point from which the popup should open relative to the iconAnchor
});
function GoogleMapHomeLeaflet(props) {
	const [mapBounds, setMapBounds] = useState([]);
	const [mapCenter, setMapCenter] = useState(null);
	const [zoom, setZoom] = useState(0);

	useEffect(() => {
		//console.log("🚀 ~ GoogleMapHomeLeaflet:22 ~ useEffect ~ props.locationLatLongArray:", props.locationLatLongArray)
		if (props.locationLatLongArray.length > 0) {
			const latitudes = props.locationLatLongArray.filter(coord=>!isNaN(coord.latitude)).map((coord) => Number(coord.latitude));
			const longitudes = props.locationLatLongArray.filter(coord=>!isNaN(coord.longitude)).map((coord) => Number(coord.longitude));
			const minLat = Math.min(...latitudes);
			const maxLat = Math.max(...latitudes);
			const minLng = Math.min(...longitudes);
			const maxLng = Math.max(...longitudes);
			setMapBounds([
				[minLat, minLng],
				[maxLat, maxLng],
			]);
			const centerLat = (minLat + maxLat) / 2;
			const centerLng = (minLng + maxLng) / 2;
			// const distance = Math.sqrt((maxLat - minLat) * (maxLat - minLat) + (maxLng - minLng) * (maxLng - minLng))
			setMapCenter([centerLat, centerLng]);
		}
	}, [props.locationLatLongArray]);

	return (
		<>
			{props.isData === true ? (
				(props.locationLatLongArray.length > 0  && mapCenter ) ? (
					<div id="map" style={{ width: "100%", height: "100%", display: "inline-block" }}>
						<MapContainer
							// ref={mapRef}
							center={mapCenter}
							// center={[props.locationLatLongArray[0].latitude ? props.locationLatLongArray[0].latitude : 18.9526,
							//               props.locationLatLongArray[0].longitude ? props.locationLatLongArray[0].longitude : 72.8182]}
							// bounds={mapBounds}
							zoom={5}
							scrollWheelZoom={true}
							style={{ width: "100%", height: "100%", display: "inline-block" }}>
							<MapComponent coordinates={props.locationLatLongArray.filter(coord=>!isNaN(coord.latitude)&&!isNaN(coord.longitude))} />
						</MapContainer>
					</div>
				) : (
					<div className="no-outlet-msg-outer">
						<div className="no-outlet-msg">
							<img src={noOutletImg} className="no-outlet-msgImg"></img>
							<p className="no-stores"> No Branches/ATM's are available!! </p>
						</div>
					</div>
				)
			) : (
				<div className="no-outlet-msg-outer">
					<div className="no-outlet-msg">
						<img src={loadingGif} className="no-outlet-msgImg" width={50}></img>
					</div>
				</div>
			)}
		</>
	);
}
export default GoogleMapHomeLeaflet;

const MapComponent = ({ coordinates }) => {
	const currentTimes = moment().format("HH:mm");
	const mapHook = useMap();
	useEffect(() => {
		if (coordinates.length > 0) {
			const bounds = L.latLngBounds(coordinates.map((marker) => [marker.latitude, marker.longitude]));
			mapHook.fitBounds(bounds);
		}
	}, [coordinates, mapHook]);
	return (
		<>
			<TileLayer
				noWrap
				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			/>
			<MarkerClusterGroup chunkedLoading>
				{coordinates.map((location, i) => (
					<Marker key={i} position={[location.latitude, location.longitude]} icon={greenIcon}>
						<Popup>
							<div>
								<div>
									<a className="mapinfo_texthead">
										<span className="mapinfo_icon"></span>
										{coordinates[i].dealerName}
									</a>
								</div>
								<div className="mapinfodetail_div">
									<span className="maplabel_axis">Address</span>
									<span className="mapcoumn_axis">:</span>
									<span className="mapaddress_axis">{coordinates[i].location +" "+ coordinates[i].City +" "+ coordinates[i].State +" "+ coordinates[i].pin_code}</span>
								</div>
								{/* <div className="mapinfodetail_div">
									<span className="maplabel_axis">Hours</span>
									<span className="mapcoumn_axis">:</span>
									<span className="mapaddress_axis text-danger" value={""}>
										{coordinates[i].customBusinessHour === "Open 24 hours" ?
										coordinates[i]?.customBusinessHour
										: 
										((moment(coordinates[i]?.openHr?.split("|")[2], 'hh:mm A').format('HH:mm') > moment(this.state.currentTimeee, 'hh:mm A').format('HH:mm')) && (moment().day() != 7)) ?
										"Will open at " + coordinates[i]?.openHr?.split("|")[2] :
										((moment(coordinates[i]?.openHr?.split("|")[3], 'hh:mm A').format('HH:mm') > moment(this.state.currentTimeee, 'hh:mm A').format('HH:mm')) && (moment().day() != 7)) ?
										"Open until " + coordinates[i]?.openHr?.split("|")[3] + "" :
										"Closed for the day"
										}

										{/* {(coordinates[i].category.includes("ATM") || coordinates[i].category.includes("CDM"))
											? coordinates[i].openHr
											: moment(coordinates[i].openHr.split("|")[2], "hh:mm A").format("HH:mm") <= moment(currentTimes, "hh:mm A").format("HH:mm") &&
											  moment(coordinates[i].openHr.split("|")[3], "hh:mm A").format("HH:mm") >= moment(currentTimes, "hh:mm A").format("HH:mm") &&
											  moment().day() != 7
											? "Open until " +
											  moment(coordinates[i].category == "Branch" && moment(coordinates[i].openHr.split("|")[3], ["hh:mm A"]).format("HH:mm"), [
													"HH:mm",
											  ]).format("hh:mm A")
											: "Closed for the day"} /***
									</span>
								</div> */}
								<div className="mapinfodetail_div">
									<span className="maplabel_axis">Contact Number</span>
									<span className="mapcoumn_axis">:</span>
									<span className="mapaddress_axis text-dager">{coordinates[i].newAddress.split("|")[5]}</span>
								</div>
								<div>
									<a href={`/${coordinates[i].seoSlug}/Home`} target="_blank" className="mapinfo_knowmore">
										know more
									</a>
								</div>
							</div>
							`
						</Popup>
					</Marker>
				))}
			</MarkerClusterGroup>
		</>
	);
};
